import { useObservable } from "../../../libs/react";
import { ICustomerContext } from "../../../services/customers/Interfaces";
import { useDeviceContext } from "../../main/AppLayout";

export function useCustomerContext() : ICustomerContext | undefined
{
    const deviceContext = useDeviceContext();
    return useObservable(deviceContext?._customers.obsSelectedCustomerContext);
}
